import { z } from 'zod';

import type {
  CreateShipmentDraftRequest,
  CreateShipmentDraftResponse,
} from './create-shipment-draft.dto.js';
import {
  ShipmentHeaderSchema,
  ShipmentRangeBuilderInputSchema,
  ShipmentReceiverSelectionSchema,
  ShipmentSourceEvidenceSchema,
  ShipmentTargetBuilderInputSchema,
  validateShipmentSourceEvidencePair,
} from './shipments-shared.schema.js';

const createShipmentDraftBaseShape = {
  companyId: z.uuid(),
  stationId: z.uuid(),
  receiver: ShipmentReceiverSelectionSchema,
  ...ShipmentSourceEvidenceSchema.shape,
};

const CreateShipmentDraftRangeSchema = ShipmentRangeBuilderInputSchema.extend(
  createShipmentDraftBaseShape,
)
  .strict()
  .superRefine(validateShipmentSourceEvidencePair);

const CreateShipmentDraftTargetSchema = ShipmentTargetBuilderInputSchema.extend(
  createShipmentDraftBaseShape,
)
  .strict()
  .superRefine(validateShipmentSourceEvidencePair);

export const CreateShipmentDraftRequestSchema: z.ZodType<CreateShipmentDraftRequest> = z
  .discriminatedUnion('mode', [CreateShipmentDraftRangeSchema, CreateShipmentDraftTargetSchema])
  .superRefine((value, ctx) => {
    const rangeStartMs = Date.parse(value.rangeStartAt);
    const rangeEndMs = Date.parse(value.rangeEndAt);
    if (!Number.isNaN(rangeStartMs) && !Number.isNaN(rangeEndMs) && rangeStartMs >= rangeEndMs) {
      ctx.addIssue({
        code: 'custom',
        message: 'rangeStartAt must be before rangeEndAt.',
        path: ['rangeEndAt'],
      });
    }
  });

export const CreateShipmentDraftResponseSchema: z.ZodType<CreateShipmentDraftResponse> = z
  .object({
    shipment: ShipmentHeaderSchema,
  })
  .strict();
